/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { InputContainer } from '@blend/enterprise-components';

export type WrappedInputConfig<T> = Omit<InputContainer.Props, 'input' | 'meta' | 'customComponentProps'> & {
  customComponentProps: T;
};

export namespace WrappedInput {
  export type Props = FieldRenderProps<any> & InputContainer.Props;
}

export const WrappedInput: React.FC<WrappedInput.Props> = ({ ...props }) => {
  return <InputContainer {...props} />;
};
